export const Logo = ({ className = "", light = false, showText = true }) => {
  // Brand mark: two overlapping angular peaks forming a stylized "A".
  // Back peak = deep navy/black, front peak = royal blue.
  const dark = light ? "#FFFFFF" : "#0C1E44";
  const royal = "#1E51A0";
  const titleColor = light ? "#FFFFFF" : "#0C1E44";
  const subColor = light ? "#8FB0E0" : "#1E51A0";

  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <svg
        width="46"
        height="40"
        viewBox="0 0 120 96"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        {/* Back hollow peak (dark) */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 6 L78 90 L58 90 L40 50 L22 90 L2 90 Z"
          fill={dark}
        />
        {/* Front solid peak (royal blue), overlapping to the right */}
        <path d="M74 20 L118 90 L86 90 L64 52 Z" fill={royal} />
        {/* small blue accent notch on the dark peak */}
        <path d="M40 6 L52 32 L40 50 L28 32 Z" fill={royal} opacity="0.0" />
      </svg>
      {showText && (
        <div className="leading-none">
          <span
            className="font-display font-bold uppercase tracking-tight text-[16px] block"
            style={{ color: titleColor }}
          >
            Almeida's
          </span>
          <span
            className="font-body uppercase tracking-[0.28em] text-[8.5px] font-medium block mt-0.5"
            style={{ color: subColor }}
          >
            Home Services LLC
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
